<script>
import Layout from "@/router/layouts/auth";
import { mapState } from "vuex";
import { api } from "@/state/services";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      loading: false,
      timer: null,

      number: "",
      seconds: 0,
      sent: false,
      correcting: false,

      code: "",
      newCellphone: "",
      password: "",
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    canResend() {
      return this.seconds <= 0 && !this.loading;
    },
    newCellphoneValid() {
      return this.newCellphone.replace(/\D/g, "").length == 11;
    },
  },
  methods: {
    getStatus() {
      api
        .get("user/cellphone")
        .then((response) => {
          if (response.data.status == "success") {
            this.number = response.data.cellphone.number;
            this.startTimer(response.data.cellphone.seconds);

            if (response.data.cellphone.status == "verified") {
              this.$router.push("/");
            }
          }
        });
    },
    startTimer(seconds) {
      this.seconds = parseInt(seconds) || 0;

      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          clearInterval(this.timer);
        }
      }, 1000);
    },
    sendCode() {
      if (this.correcting && (!this.newCellphoneValid || !this.password)) {
        this.$toast.error('Preencha todos os campos obrigatórios.');
        return;
      }

      this.loading = true;

      const params = this.correcting ? { cellphone: "+55." + this.newCellphone.replace(/\D/g, ""), password: this.password } : {};

      api
        .post("user/cellphone/send", params)
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(response.data.message);

            this.number = response.data.cellphone.number;
            this.sent = true;
            this.correcting = false;
            this.password = "";
            this.code = "";
            this.startTimer(response.data.cellphone.seconds);
          } else {
            this.$toast.error(response.data.message);

            if (response.data.seconds) {
              this.startTimer(response.data.seconds);
            }
          }

          this.loading = false;
        })
        .catch((error) => {
          if (error) {
            this.loading = false;
          }
        });
    },
    verifyCode() {
      if (this.code.length != 6) {
        this.$toast.error('Digite o código de 6 dígitos.');
        return;
      }

      this.loading = true;

      api
        .post("user/cellphone/verify", { code: this.code })
        .then((response) => {
          if (response.data.status == "success") {
            this.$toast.success(response.data.message);

            this.$store.state.account.user.cellphone_status = "verified";
            this.$router.push("/");
          } else {
            this.$toast.error(response.data.message);
          }

          this.loading = false;
        })
        .catch((error) => {
          if (error) {
            this.loading = false;
          }
        });
    },
    startCorrection() {
      this.correcting = true;
      this.sent = false;
    },
    cancelCorrection() {
      this.correcting = false;
      this.password = "";
      this.newCellphone = "";
    },
    logout() {
      this.$router.push("/logout");
    },
  },
  mounted() {
    this.getStatus();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-2 text-center">
          <img class="w-100" style="max-width: 150px" src="@/assets/images/logo.png" />
        </div>
        <div v-if="account.user && account.user.username" class="card rounded-lg mt-3 mb-0">
          <div class="card-body py-3 text-left d-flex align-items-center">
            <div class="flex-fill">
              <p class="mb-0 text-muted notranslate">{{ account.user.username }}</p>
              <p class="mb-0 font-weight-bold text-uppercase notranslate">{{ account.user.name }}</p>
            </div>
            <b-button variant="outline-dark" class="ml-3" @click="logout">
              Sair
            </b-button>
          </div>
        </div>
        <div class="py-5">
          <h4 class="mb-3">Valide seu celular</h4>

          <!-- Correção do número (usuário ainda não validado) -->
          <b-form v-if="correcting" @submit.prevent="sendCode">
            <b-form-group label="Novo celular" label-for="new-cellphone">
              <b-form-input id="new-cellphone" v-model="newCellphone" v-mask="'(##) #####-####'" type="text" inputmode="numeric" placeholder="(11) 99999-9999"></b-form-input>
            </b-form-group>
            <b-form-group label="Senha atual" label-for="password">
              <b-form-input id="password" v-model="password" type="password" autocomplete="current-password"></b-form-input>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="!canResend" type="submit" variant="default" class="btn-lg btn-block">
                {{ seconds > 0 ? 'Reenviar em ' + seconds + 's' : 'Enviar código para o novo número' }}
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
              <b-button variant="outline-default" class="btn-lg btn-block mt-4" @click="cancelCorrection">Voltar</b-button>
            </div>
          </b-form>

          <!-- Envio do código -->
          <div v-else-if="!sent">
            <p class="text-muted">Enviaremos um código de 6 dígitos para o seu WhatsApp para confirmar este número.</p>
            <p class="font-weight-bold notranslate">{{ number }}</p>
            <div class="mt-4">
              <b-button :disabled="!canResend" variant="default" class="btn-lg btn-block" @click="sendCode">
                {{ seconds > 0 ? 'Reenviar em ' + seconds + 's' : 'Enviar código' }}
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </div>
          </div>

          <!-- Conferência do código -->
          <b-form v-else @submit.prevent="verifyCode">
            <p class="text-muted">
              Digite o código enviado para
              <span class="font-weight-bold notranslate">{{ number }}</span>
            </p>
            <b-form-group label="Código" label-for="code">
              <b-form-input id="code" v-model="code" type="text" inputmode="numeric" maxlength="6" autocomplete="one-time-code" class="text-center" style="letter-spacing: 8px; font-size: 24px"></b-form-input>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading" type="submit" variant="default" class="btn-lg btn-block">
                Validar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
              <b-button :disabled="!canResend" variant="link" class="btn-block mt-2" @click="sendCode">
                {{ seconds > 0 ? 'Reenviar em ' + seconds + 's' : 'Reenviar código' }}
              </b-button>
            </div>
          </b-form>

          <div v-if="!correcting" class="mt-4">
            <b-button variant="outline-default" class="btn-lg btn-block" @click="startCorrection">
              Corrigir meu número
            </b-button>
          </div>
        </div>
        <div class="mt-4 text-center">
          <p class="m2n-logo font-size-12 text-uppercase text-muted">
            <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=lojahd1001.com.br&utm_medium=link&utm_campaign=logo">
              TECNOLOGIA POR M2N
            </a>
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
